import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ListCampaignsParams,
  ListCampaignsResponse,
  UpdateCampaignResponse,
  CreateCampaignResponse,
  Campaign,
} from 'src/app/core/proto/billposter';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class CampaignsService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Get list of campaigns
   * @param listCampaignsParams
   */
  listCampaigns(
    listCampaignsParams: ListCampaignsParams
  ): Observable<ListCampaignsResponse> {
    let params = new HttpParams();

    Object.keys(listCampaignsParams).forEach((param) => {
      if (param !== 'campaignStatusFilters') {
        params = params.append(param, listCampaignsParams[param]);
      } else {
        for (let filterStatusParam of listCampaignsParams.campaignStatusFilters) {
          params = params.append(param, filterStatusParam);
        }
      }
    });

    return this.apiService.get(`/v1/campaigns/list`, params);
  }

  /**
   * Update campaign
   * @param campaign
   */
  updateCampaign(campaign: Campaign): Observable<UpdateCampaignResponse> {
    return this.apiService.put(
      `/v1/campaigns/campaign/${campaign.campaignUuid}`,
      campaign
    );
  }

  /**
   * Create campaign
   * @param campaign
   */
  createCampaign(campaign: Campaign): Observable<CreateCampaignResponse> {
    return this.apiService.post(`/v1/campaigns`, campaign);
  }

  /**
   * Create manual campaign
   * @param campaign
   * @param file
   */
  createManualCampaign(campaign: Campaign, file): any {
    let formData = new FormData();
    formData.append('file', file);
    Object.keys(campaign).forEach((key) => {
      if (campaign[key]) {
        if (key === 'messages' && campaign.messages[0]?.body) {
          formData.append('messageBody', campaign.messages[0]?.body);
        } else if (key === 'startTs') {
          formData.append('startTs', campaign.startTs.toISOString());
        } else {
          formData.append(key, campaign[key]);
        }
      }
    });

    return this.apiService.postMultipart(`/v1/campaigns/manual`, formData);
  }
}
